// src/hooks/useBilgiSayfasiUrl.ts
//
// ANLATIM YÜZEYİ ↔ ADRES ÇUBUĞU (5★ / Gold / MyCards / yolculuk).
//
// Neden KANCA, neden çağrı yerlerinde değil: bu dört sheet ÜÇ ayrı yerden
// mount ediliyor (`ProfileMobile`, `ProfileDesktop`, global lazy-host
// `infoSheetHost`). URL yazımını çağrı yerlerine dağıtmak, aynı kuralın üç
// kopyası demekti — bu depoda çürüyen listelerin sınıfı tam olarak bu. Kural
// sheet'in KENDİSİNDE yaşar: nereden mount edilirse edilsin adres çubuğu aynı
// davranır.
//
// Push/replace/geri-tuşu mekaniği burada DEĞİL — `useKatmanUrl`de (koleksiyon
// detayıyla ORTAK). Burası yalnız HEDEFİ üretir.

import useKatmanUrl from "./useKatmanUrl";
import { bilgiYolu, bilgiYolundaMi } from "../app/bilgiSayfasiUrl";

export default function useBilgiSayfasiUrl(
  konu: string,
  open: boolean,
  onClose: () => void,
): void {
  useKatmanUrl({
    hedef: bilgiYolu(konu),
    open,
    onClose,
    yoldaMi: bilgiYolundaMi,
  });
}
